import { NotificationService } from "../notification/notification.service";

export const copyToClipboard = (copyText) => {
  navigator.clipboard.writeText(copyText).then(
    function () {
      NotificationService.showNotification({
        text: "Info copied to Clipboard",
        timeout: 5000,
      });
      // setTimeout(() => {
      //   NotificationService.showNotification({
      //     text: "You must unlock invoice to edit contact",
      //     timeout: 5000,
      //   });
      //   setTimeout(() => {
      //     NotificationService.showNotification({
      //       text: "You must unlock invoice to edit contact Again",
      //       timeout: 5000,
      //     });
      //   }, 2000);
      // }, 2000)
    },
    function (err) {
      NotificationService.showNotification({
        text: "Text could not be copied to clipboard",
        timeout: 2000,
        type: "error",
      });
    }
  );
}